// Location-specific landing pages – concise but unique per area.

export const locations = [
  {
    slug: "downtown-dubai",
    name: "Downtown Dubai",
    title: "Personal Trainer Downtown Dubai | Corrective Motion",
    description:
      "Elite personal trainer in Downtown Dubai. Corrective exercise, strength, and fat loss coaching inside Dubai Mall · Zabeel Expansion.",
    lead:
      "Corrective Motion operates in the heart of Downtown Dubai, inside Train Strength & Fitness at the Dubai Mall Zabeel Expansion. It is one of the most convenient premium training addresses in the city for residents of Downtown, Business Bay, and DIFC.",
    highlights: [
      "5 minutes walking from most Downtown residences",
      "Private, low-density training environment",
      "Direct Metro connection via Burj Khalifa/Dubai Mall station",
    ],
    audience:
      "Ideal for executives, professionals, and residents in Downtown Dubai who want elite corrective training close to home or the office.",
  },
  {
    slug: "difc-dubai",
    name: "DIFC",
    title: "Personal Trainer DIFC | Elite Coaching by Corrective Motion",
    description:
      "Personal trainer for DIFC professionals. Evidence-based corrective exercise, posture correction, and strength coaching a short drive from DIFC.",
    lead:
      "DIFC's professional community is one of the most demanding in the world, with long hours at the desk, high stress, and tight schedules. Corrective Motion offers a specialist personal training service designed for exactly that lifestyle, minutes away from DIFC.",
    highlights: [
      "Founder previously coached DIFC professionals for over a decade",
      "Focus on desk-driven postural issues",
      "Session slots that fit high-executive schedules",
    ],
    audience:
      "Built for bankers, lawyers, and senior professionals in DIFC looking for premium 1:1 training with clinical precision.",
  },
  {
    slug: "business-bay-dubai",
    name: "Business Bay",
    title: "Personal Trainer Business Bay Dubai | Corrective Motion",
    description:
      "Personal trainer in Business Bay Dubai specialising in corrective exercise, posture, strength, and fat loss coaching.",
    lead:
      "Business Bay's dense residential-professional mix is one of the fastest growing training markets in Dubai. Corrective Motion serves Business Bay residents from a premium base a short drive across the water in Dubai Mall.",
    highlights: [
      "Short drive from Business Bay towers",
      "Private premium training space",
      "Programmes designed for busy professional schedules",
    ],
    audience: "Ideal for Business Bay residents and professionals who want a high-end trainer with a clinical approach.",
  },
  {
    slug: "sheikh-zayed-road-dubai",
    name: "Sheikh Zayed Road",
    title: "Personal Trainer Sheikh Zayed Road | Corrective Motion Dubai",
    description:
      "Elite personal training a short drive from Sheikh Zayed Road. Corrective exercise, strength, and posture coaching by Anoop Gopi.",
    lead:
      "For residents along Sheikh Zayed Road, from Trade Centre to Al Wasl, Corrective Motion offers a premium training address a short drive away in the Zabeel Expansion of Dubai Mall.",
    highlights: [
      "Central location for SZR corridor",
      "Executive-friendly time slots",
      "Direct highway access",
    ],
    audience: "Perfect for professionals living or working along Sheikh Zayed Road.",
  },
  {
    slug: "jumeirah-dubai",
    name: "Jumeirah",
    title: "Personal Trainer Jumeirah Dubai | Corrective Motion",
    description:
      "Premium personal trainer serving Jumeirah residents. Corrective exercise, mobility, strength, and pain-free performance training.",
    lead:
      "Jumeirah residents value privacy, quality, and expertise. Corrective Motion delivers all three: a specialist personal training service, focused on movement quality and long-term health, easily accessible from Jumeirah 1, 2, and 3.",
    highlights: [
      "Serves families and individuals across Jumeirah",
      "Ideal for post-injury or older adult training",
      "Pre & Post Natal certified",
    ],
    audience: "Suited to Jumeirah residents seeking a premium, results-driven, evidence-based training experience.",
  },
  {
    slug: "dubai-marina",
    name: "Dubai Marina",
    title: "Personal Trainer Dubai Marina | Corrective Motion",
    description:
      "Personal trainer for Dubai Marina residents. Elite corrective exercise, strength, and fat loss coaching from Anoop Gopi.",
    lead:
      "Dubai Marina's community is a mix of performance-driven professionals and lifestyle-focused expats. Corrective Motion offers a specialist service designed for both, from posture correction to sustainable fat loss and athletic performance.",
    highlights: [
      "Serves the Marina, JBR, and Bluewaters",
      "Online coaching for those who prefer training at home",
      "In-person sessions available in Downtown premium studio",
    ],
    audience: "Great fit for Dubai Marina professionals, athletes, and lifestyle-focused expats.",
  },
  {
    slug: "palm-jumeirah-dubai",
    name: "Palm Jumeirah",
    title: "Personal Trainer Palm Jumeirah | Corrective Motion Dubai",
    description:
      "Premium personal trainer for Palm Jumeirah residents. Corrective exercise, mobility, strength, and joint-friendly coaching by Anoop Gopi.",
    lead:
      "Palm Jumeirah residents demand discretion, quality, and precision. Corrective Motion delivers all three with an elite 1:1 personal training service built on assessment, evidence, and long-term outcomes.",
    highlights: [
      "Serves villa and apartment residents on the Palm",
      "Sessions available in-person or online",
      "Discreet, professional coaching relationship",
    ],
    audience: "Designed for Palm Jumeirah residents who want elite corrective coaching without gym crowds.",
  },
  {
    slug: "jvc-dubai",
    name: "JVC (Jumeirah Village Circle)",
    title: "Personal Trainer JVC Dubai | Corrective Motion",
    description:
      "Personal trainer for JVC residents. Evidence-based corrective exercise, strength, and fat loss coaching by Anoop Gopi.",
    lead:
      "JVC has grown into one of Dubai's most dynamic residential communities. Corrective Motion offers residents a premium personal training option, in-person or online, focused on measurable movement and body composition results.",
    highlights: [
      "Online programming for at-home training",
      "Fat loss and muscle building specialisation",
      "In-person sessions available in Downtown",
    ],
    audience: "Ideal for JVC residents balancing family life, work, and fitness.",
  },
  {
    slug: "motor-city-dubai",
    name: "Motor City",
    title: "Personal Trainer Motor City Dubai | Corrective Motion",
    description:
      "Elite personal trainer serving Motor City. Corrective exercise, strength coaching, and pain-free performance from Anoop Gopi.",
    lead:
      "Motor City's community is home to professionals, families, and athletes. Corrective Motion serves each with tailored 1:1 or online programming built on the same clinical foundation.",
    highlights: [
      "Online coaching packages",
      "In-person Downtown sessions",
      "Programming for parents balancing time",
    ],
    audience: "Fits Motor City residents wanting elite coaching without commuting into the city.",
  },
  {
    slug: "arabian-ranches-dubai",
    name: "Arabian Ranches",
    title: "Personal Trainer Arabian Ranches | Corrective Motion Dubai",
    description:
      "Personal trainer for Arabian Ranches families. Corrective exercise, strength, and joint-friendly coaching for all ages.",
    lead:
      "Arabian Ranches residents value long-term health, family well-being, and joint-friendly training. Corrective Motion delivers all three with programmes tailored to all ages and fitness levels.",
    highlights: [
      "Senior fitness certified",
      "Pre & Post Natal certified",
      "Family-friendly scheduling",
    ],
    audience: "Great fit for Arabian Ranches families with multi-generational fitness needs.",
  },
  {
    slug: "al-barsha-dubai",
    name: "Al Barsha",
    title: "Personal Trainer Al Barsha Dubai | Corrective Motion",
    description:
      "Personal trainer for Al Barsha. Evidence-based corrective exercise, strength, and posture coaching by Anoop Gopi.",
    lead:
      "Al Barsha's central location makes it ideal for professionals looking to train with a specialist personal trainer close to work. Corrective Motion offers 1:1 sessions and online packages that fit any weekly schedule.",
    highlights: [
      "Central Dubai location",
      "Executive scheduling",
      "Corrective and strength specialisation",
    ],
    audience: "Ideal for Al Barsha professionals and residents.",
  },
];

export const findLocationBySlug = (slug) => locations.find((l) => l.slug === slug);
